import { Helmet } from 'react-helmet-async';

const DEFAULT_IMAGE = 'https://www.roomia.net/favicon.png';
const SITE_NAME = 'Roomia.net';

const MetaTags = ({
  title,
  description,
  image,
  url,
  type = 'website',
  noindex = false,
}) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Logements meublés en Afrique`;
  const finalDescription = description || "Trouvez facilement votre logement meublé au Cameroun et en Afrique sur Roomia.net.";
  const finalImage = image || DEFAULT_IMAGE;
  const finalUrl = url || (typeof window !== 'undefined' ? window.location.href : 'https://www.roomia.net');

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={finalDescription} />
      <link rel="canonical" href={finalUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={finalImage} />
      <meta property="og:image:alt" content={title || SITE_NAME} />
      <meta property="og:url" content={finalUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="fr_FR" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={finalImage} />

      {noindex && <meta name="robots" content="noindex,nofollow" />}
    </Helmet>
  );
};

export default MetaTags;
